import React from "react";

const PaginationItem = ({
	disabled = false,
	onClick,
	text,
	hideMobile = true,
}) => (
	<li
		className={`page-item ${disabled && "disabled"} ${
			hideMobile && "d-none d-md-block"
		}`}
	>
		<button onClick={onClick} className={`page-link`}>
			{text}
		</button>
	</li>
);

const Pagination = ({ page, pageCount, initialPage, setPage }) => {
	const shouldTrim = (idx) => {
		return idx > 3 && idx < pageCount - 4;
	};

	const isCurrent = (idx) => idx === page;

	const includeElipses = (idx) => {
		if (pageCount <= 9) {
			return false;
		}
		return idx === 3 || (shouldTrim(idx) && isCurrent(idx));
	};

	return (
		<nav aria-label="Pagination">
			<ul className="pagination">
				<PaginationItem
					disabled={page === initialPage}
					onClick={() => setPage(page - 1)}
					text="Previous"
					hideMobile={false}
				/>

				{[...Array(pageCount)].map((_, idx) => (
					<React.Fragment key={idx}>
						{shouldTrim(idx) && !isCurrent(idx) ? (
							<></>
						) : (
							<>
								<PaginationItem
									disabled={page === idx}
									onClick={() => setPage(idx)}
									text={idx + 1}
								/>

								{includeElipses(idx) && (
									<PaginationItem
										disabled={true}
										text="..."
									/>
								)}
							</>
						)}
					</React.Fragment>
				))}
				<PaginationItem
					disabled={pageCount === page + 1}
					onClick={() => setPage(page + 1)}
					text="Next"
					hideMobile={false}
				/>
			</ul>
		</nav>
	);
};

export default Pagination;
